import { render, staticRenderFns } from "./LockerDescription.vue?vue&type=template&id=727b39ae&scoped=true"
import script from "./LockerDescription.vue?vue&type=script&lang=ts"
export * from "./LockerDescription.vue?vue&type=script&lang=ts"
import style0 from "./LockerDescription.vue?vue&type=style&index=0&id=727b39ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727b39ae",
  null
  
)

export default component.exports